// This file is to make importing elsewhere in the project cleaner/easier.
import { Config } from './config';
import { Scope } from './scope';
import { Scopes } from './scopes';
import {
    Notification,
    networkNotification,
    serverNotification,
    clientNotification,
    notFoundNotification,
    unknownErrorNotification } from './notification';

export {
    Config,
    Scope,
    Scopes,
    networkNotification,
    serverNotification,
    clientNotification,
    notFoundNotification,
    unknownErrorNotification,
    Notification
};




// WEBPACK FOOTER //
// D:/a/1/s/src/app/entities/entities.ts